import { React, useState } from "react";
import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import swal from "sweetalert";
import useSWR from "swr";
import useAuth from "../../../../../../initialpage/hooks/useAuth";
import NotFoundPage from "../../../../StoreComponents/NotFoundPage";
import { API } from "../../../../StoreComponents/conflict";
import { PostStoreLog } from "../../../../StoreComponents/hooks/useStoreLog";
import moment from "moment";
import Cookies from "js-cookie";
const fetcher = (url) => API.get(url).then((res) => res.data.data);
const fetcher1 = (url) =>
  API.get(url, {
    headers: {
      search: `%%`,
    },
  }).then((res) => res.data.data);

const AddMoreMRR = () => {
  const navigate = useNavigate();
  const { info } = useParams();
  const [productOption, setProductOption] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [entryTypeValue, setEntryTypeValue] = useState("");
  const [selectedProduct, setSelectedProduct] = useState("");
  const [singleProductData, setSingleProductData] = useState({});
  const [selectedUnit, setSelectedUnit] = useState("");
  const array = info.split("&");
  console.log(array[0], array[1]);

  const {
    data: AddMRRDetails,
    error,
    mutate,
  } = useSWR(
    array[0] && array[1]
      ? `store/mrr/productReceptBySupIdMrr/${array[0]}/${array[1]}`
      : null,
    fetcher
  );
  console.log(AddMRRDetails);
  // get categoryData
  const { data: categoryOption, error: error2 } = useSWR(
    `store/settings/categories?page=${0}&limit=${10000}`,
    fetcher1
  );

  // get UnitData
  const { data: unitOption, error: error3 } = useSWR(
    `store/settings/units?page=${0}&limit=${10000}`,
    fetcher1
  );
  // handle Category select;
  const handleCategory = (name) => {
    const id = name.value;

    setSelectedCategory(name.value);

    API.get(
      `store/settings/productByCatId/${id}?page=${0}&limit=${100000}`
    ).then((res) => setProductOption(res.data.data));
  };

  // handle product select;
  const handleProduct = (product) => {
    console.log(product);
    setSelectedProduct(product.value);
    API.get(`store/products/storeProducts/${product.value}`).then((res) => {
      console.log(res);
      if (!res.data.data) {
        setEntryTypeValue("New");
        setSingleProductData({});
      } else {
        setEntryTypeValue("Existing");
        setSingleProductData(res.data.data);
      }
    });
  };
  // set category select list
  let category = [];
  if (categoryOption && categoryOption.length > 0) {
    category = categoryOption.map((data) => {
      let optionsItem = {};
      optionsItem.value = data.cat_id;
      optionsItem.label = `${data.categoryen} (${data.categorybn})`;
      return optionsItem;
    });
  }

  // set Product select list
  let productCategory = [];
  if (productOption && productOption.length > 0) {
    productCategory = productOption.map((data) => {
      let optionsItem = {};
      optionsItem.value = data.prodid;
      optionsItem.label = `${data.proname} - ${data.pronametwo}`;
      return optionsItem;
    });
  }

  // set Unit select list
  let unitCategory = [];
  if (unitOption && unitOption.length > 0) {
    unitCategory = unitOption.map((data) => {
      let optionsItem = {};
      optionsItem.value = data.unit_id;
      optionsItem.label = `${data.unit}`;
      return optionsItem;
    });
  }
  // handle Unit select;
  const handleUnit = (name) => {
    setSelectedUnit(name.value);
  };

  // console.log(productOption);
  console.log(AddMRRDetails);
  // console.log(singleProductData);

  const { register, handleSubmit, reset } = useForm();
  const user = JSON.parse(Cookies.get("user") || '{}');
  const onSubmit = (data) => {
    swal({
      title: "Are you sure?",
      //  text: "Once deleted, you will not be able to recover this imaginary file!",
      buttons: true,
      //  dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        if (entryTypeValue === "New") {
          data.entryType = "New";
          data.productid = parseInt(selectedProduct);
          data.mrrno = parseInt(array[1]);
          data.supplier = parseInt(array[0]);
          data.username = user?.name_english;
          data.newqty = parseFloat(data.newqty);
          data.newprice = parseFloat(data.newprice);
          data.unit = parseInt(selectedUnit);
          data.stockalert = parseInt(data.stockalert);
          data.category = parseInt(selectedCategory);
          console.log(data);
          API.put("store/mrr/addMoreMrr", data).then((res) => {
            console.log(res);
            if (res) {
              swal({
                title: "Thank You !",
                text: "Successfully Added",
                icon: "success",
                button: "Ok",
              });
              PostStoreLog(2, "Add more Mrrr");
              setSelectedCategory("");
              setEntryTypeValue("");
              setSelectedProduct("");
              setSelectedUnit("");
              mutate();
              setSingleProductData({});
              window.location.reload();
            }
          });
        } else {
          data.entryType = "Old";
          data.productid = parseInt(singleProductData?.PROID);
          data.mrrno = parseInt(array[1]);
          data.supplier = parseInt(array[0]);
          data.username = user?.name_english;
          data.newqty = parseFloat(data.newqty);
          data.newprice = parseFloat(data.newprice);
          data.category = parseInt(selectedCategory);
          console.log(data);
          API.put("store/mrr/addMoreMrr", data).then((res) => {
            console.log(res);
            if (res) {
              swal({
                title: "Thank You !",
                text: "Successfully Added",
                icon: "success",
                button: "Ok",
              });
              setSelectedCategory("");
              PostStoreLog(2, "Add more mrr");
              setEntryTypeValue("");
              mutate();
              setSelectedProduct("");
              setSelectedUnit("");
              window.location.reload();
              setSingleProductData({});
            }
          });
        }
      } else {
        swal("Your imaginary file is safe!");
      }
    });
  };

  return (
    <>
      <Helmet>
        <title>Add More Material Recipient Requirement (MRR) - BBA STORE</title>
        <meta
          name="description"
          content="Add More Material Recipient Requirement (MRR) - BBA STORE"
        />
      </Helmet>
      <style type="text/css">
        {
          "table th ,table  td{ font-size:1.1rem} label{font-size:1rem !important}"
        }
      </style>

      <div className="page-wrapper">
        <div className="content container-fluid main-container">
          <div className="d-flex justify-content-between">
            <div>
              <button
                onClick={() => navigate(-1)}
                class="btn btn-o ms-1 mb-3"
                style={{
                  background: "#000",
                  color: "#fff",
                  borderRadius: "10px",
                }}
              >
                <i class="fa fa-hand-o-left"></i> Back
              </button>
            </div>
            <div></div>
          </div>
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h3 className="text-start text-dark">
              Add More Material Recipient Requirement (MRR)
            </h3>
          </div>

          <div
            className="my-4 table-container p-2"
            style={{ background: "white", borderRadius: "10px" }}
          >
            <div>
              {!AddMRRDetails ? (
                <NotFoundPage />
              ) : (
                <div className="row gx-5">
                  <div className="col-12 col-md-6 col-lg-6">
                    <div className="">
                      <div className="table-responsive-sm data-table">
                        <table className="table table-bordered table-striped">
                          <thead>
                            <tr className=" tableColor">
                              <th colSpan="12" className="fs-6 py-2">
                                Product Supplier Details{" "}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr className="lh-lg">
                              <td colSpan="3">Entry Date</td>
                              <td colSpan="3">
                                {AddMRRDetails?.entriesInfo.entridate}
                              </td>
                              <td colSpan="3">MRR No.</td>
                              <td colSpan="3" className="fw-bold">
                                {AddMRRDetails?.entriesInfo.mrrnno}
                              </td>
                            </tr>

                            <tr className="lh-lg">
                              <td colSpan="3">Supplier Name</td>
                              <td colSpan="3" className="fw-bold">
                                {AddMRRDetails?.suppliers.supplier}
                              </td>
                              <td colSpan="3">Date</td>
                              <td colSpan="3">
                                {moment(
                                  AddMRRDetails?.entriesInfo.suppdate
                                ).format("DD-MM-YYYY")}
                              </td>
                            </tr>

                            <tr className="lh-lg">
                              <td colSpan="3">Work Order No.</td>
                              <td colSpan="3">
                                {" "}
                                {AddMRRDetails?.entriesInfo.workorder}
                              </td>
                              <td colSpan="3">Date</td>
                              <td colSpan="3">
                                {moment(
                                  AddMRRDetails?.entriesInfo.workodate
                                ).format("DD-MM-YYYY")}
                              </td>
                            </tr>

                            <tr className="lh-lg">
                              <td colSpan="3">Cash Memo/Bill/Challan No.</td>
                              <td colSpan="3">
                                {" "}
                                {AddMRRDetails?.entriesInfo.cashmemono}
                              </td>
                              <td colSpan="3">Date</td>
                              <td colSpan="3">
                                {moment(
                                  AddMRRDetails?.entriesInfo.cashmemodate
                                ).format("DD-MM-YYYY")}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className="py-5">
                        <h3 className="text-center">Add More Products</h3>
                        <form onSubmit={handleSubmit(onSubmit)}>
                          <div className="row">
                            <div className="col-sm-9">
                              {" "}
                              <label htmlFor="product_category">
                                Category <span className="color-red">*</span>
                              </label>
                              <Select
                                onChange={handleCategory}
                                style={{ borderRadius: "10px" }}
                                className="text-start fs-6"
                                options={category}
                              />
                              <input
                                tabIndex={-1}
                                autoComplete="off"
                                style={{ opacity: 0, height: 0 }}
                                defaultValue={selectedCategory}
                                required
                              />
                            </div>
                            <div className="col-sm-3">
                              <label htmlFor="ProStatus">Product Status</label>
                              <input
                                defaultValue={entryTypeValue}
                                type="text"
                                className="input-field-new p-2"
                                disabled
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12">
                              <label htmlFor="product_category">
                                Product Name{" "}
                                <span className="color-red">*</span>
                              </label>
                              <Select
                                onChange={handleProduct}
                                menuPlacement="top"
                                style={{ borderRadius: "10px" }}
                                className="text-start fs-6"
                                options={productCategory}
                              />
                              <input
                                tabIndex={-1}
                                autoComplete="off"
                                style={{ opacity: 0, height: 0 }}
                                defaultValue={selectedProduct}
                                required
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-6">
                              {" "}
                              <label htmlFor="ProStatus">
                                Quantity(Old Qty: {singleProductData?.PROQTY})
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                {...register("newqty")}
                                type="number"
                                className="input-field-new p-2"
                                required
                              />
                            </div>
                            <div className="col-sm-6">
                              {" "}
                              <label htmlFor="ProStatus">
                                Amount(Old Price:{" "}
                                {singleProductData?.STOCKPRICE})
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                {...register("newprice")}
                                // defaultValue={MRRData}
                                type="number"
                                className="input-field-new p-2"
                                required
                              />
                            </div>
                          </div>
                          <div className="row mt-3">
                            {entryTypeValue === "New" ? (
                              <div className="col-sm-6">
                                <label htmlFor="ProStatus">
                                  Alert Quantity
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  {...register("stockalert")}
                                  type="number"
                                  defaultValue={
                                    singleProductData
                                      ? singleProductData.STOCKALERT
                                      : 0
                                  }
                                  className="input-field-new p-2"
                                  required
                                />
                              </div>
                            ) : (
                              <div className="col-sm-6">
                                <label htmlFor="ProStatus">
                                  Alert Quantity
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  defaultValue={
                                    singleProductData
                                      ? singleProductData.STOCKALERT
                                      : 0
                                  }
                                  type="number"
                                  className="input-field-new p-2"
                                />
                              </div>
                            )}

                            {entryTypeValue === "New" ? (
                              <div className="col-sm-6">
                                {" "}
                                <label htmlFor="Unit" className="">
                                  Unit <span className="color-red">*</span>
                                </label>
                                <Select
                                  onChange={handleUnit}
                                  menuPlacement="top"
                                  style={{ borderRadius: "10px" }}
                                  className="text-start fs-6"
                                  options={unitCategory}
                                />
                                <input
                                  tabIndex={-1}
                                  autoComplete="off"
                                  style={{ opacity: 0, height: 0 }}
                                  defaultValue={selectedUnit}
                                  required
                                />
                              </div>
                            ) : (
                              <div className="col-sm-6">
                                {" "}
                                <label htmlFor="Unit" className="">
                                  Unit <span className="color-red">*</span>
                                </label>
                                <Select
                                  onChange={handleUnit}
                                  placeholder={singleProductData?.UNIT}
                                  menuPlacement="top"
                                  style={{ borderRadius: "10px" }}
                                  className="text-start fs-6"
                                  options={unitCategory}
                                />
                              </div>
                            )}
                          </div>
                          <div className="text-center mt-5">
                            <button
                              type="sumbit"
                              className="px-3  py-1 btn-color_store"
                              style={{
                                textAlign: "center",
                                borderRadius: "5px",
                                border: "none",
                              }}
                            >
                              <i className="fa fa-file fs-6 me-1 "></i> Save
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-6 col-lg-6">
                    <div>
                      <div className="table-responsive-sm data-table">
                        <table className="table table-bordered table-striped">
                          <thead>
                            <tr className="tableColor  mb-1">
                              <th colSpan="12" className="fs-6 py-2">
                                MRR Product Details
                              </th>
                            </tr>
                            <tr className="tableColor">
                              <th colSpan="2">S/N </th>
                              <th colSpan="2">Category</th>
                              <th colSpan="2">Product</th>
                              <th colSpan="2">Unit</th>
                              <th colSpan="2">Qty</th>
                              <th colSpan="2">Price</th>
                            </tr>
                          </thead>

                          {AddMRRDetails.entriLists && (
                            <tbody>
                              {AddMRRDetails.entriLists.map(
                                (product, index) => (
                                  <tr className="lh-lg" key={index}>
                                    <td colSpan="2">{++index} </td>
                                    <td colSpan="2">{product.categoryen}</td>
                                    <td colSpan="2">{product.proname}</td>
                                    <td colSpan="2">{product.unit}</td>
                                    <td colSpan="2">{product.proqty}</td>
                                    <td colSpan="2">{product.stockprice}</td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          )}
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddMoreMRR;
